module.exports = __webpack_public_path__ + "static/media/quickly.2b3474f7.svg";